import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { calculateDetailAmount } from "src/utils/calculation/calculationUtils";
import { WMS1131_R01DetailDto } from "../Dto_WMS1131_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
interface UseWMS1131_R01CellChangeProps {
	WMS1131_R01DetailList: WMS1131_R01DetailDto[];
	originalWMS1131_R01DetailList: WMS1131_R01DetailDto[];
	updateWMS1131_R01DetailList: (index: number, data: WMS1131_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<WMS1131_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
	customCd?: string;
}

export function useWMS1131_R01CellChange({
	WMS1131_R01DetailList,
	originalWMS1131_R01DetailList,
	updateWMS1131_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
	customCd,
}: UseWMS1131_R01CellChangeProps) {
	const { searchExactItemCode } = useCodeSearch({});
	const WMS1131R01Config = createModuleConfig.WMS1131();

		 // PROGRAM 공통코드에서 ITEM_POPUP_SEARCH의 ref01 값으로 필터 사용 여부 결정
		 const { programList } = useCommonCodeStore();
		 const useCustomCdFilter =
			 programList.find(c => c.minorCd === 'ITEM_POPUP_SEARCH')?.ref01 === 'Y';

	const fieldConfigWithSearch = {
		...WMS1131R01Config.fieldConfig,
		codeSearchFields: {
			...WMS1131R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...WMS1131R01Config.fieldConfig.codeSearchFields!.itemCd,
				searchFilters: () =>
					useCustomCdFilter && customCd?.trim() ? { customCd: customCd.trim() } : undefined,
				searchFunction: searchExactItemCode,
				canOpenModal: (row: WMS1131_R01DetailDto) => !!row?.inserted,
			},
		},
	};

	const WMS1131_FIELD_MAPPING = {
		qtyField: "qty",
		priceField: "cost",
		dcField: "dcAmt",
		amountField: "amt",
		preventNegative: true,
	};

	const calculateAmount = (data: WMS1131_R01DetailDto): WMS1131_R01DetailDto => {
		return calculateDetailAmount(data, WMS1131_FIELD_MAPPING);
	};

	return useCommonDetailTableHandlers<WMS1131_R01DetailDto>({
		detailList: WMS1131_R01DetailList,
		updateDetailList: updateWMS1131_R01DetailList,
		originalDetailList: originalWMS1131_R01DetailList,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: WMS1131R01Config.codeSearchConfig,
		calculateAmount,
	});
}
